/**
 * @ngdoc services
 * @memberof mercury.modules.time.payroll
 * @name TimePayrollAdjustment
 * @description Data access service for managing payrate adjustments
 * Cook brothers adjustments
 * We can still use Adjustment within the controller/route/factory but not once we are interrogating any data from Cyrus
 */
angular.module('mercury.modules.time.payroll.adjustment')
.factory('TimePayrollAdjustment', ["$resource", "$q", "userinfo", "settings", function($resource, $q, userinfo, settings) {
  var Adjustments = $resource(settings.mercHost + '/time-payroll-adjustments/:id', {id: '@id'});

  /**
   * Get a list of all payrate adjustments
   *
   * @memberof TimePayrollAdjustment
   */
  function getAll() {
    return Adjustments.query().$promise;
  }

  /**
   * Get a list of all active payrate adjustments
   *
   * @memberof TimePayrollAdjustment
   */
  function getAllActive() {
    if (userinfo.companyHasPermission('Payroll')) {
      return Adjustments.query({
        $filter: 'DatestampDeleted eq null'
      }).$promise;
    } else {
      var p = $q.defer();
      p.resolve([]);
      return p.promise;
    }
  }

  /**
   * Get a payrate adjustment based on teh range of a clock
   *
   * @memberof TimePayrollAdjustment
   * @param  {String} clockinTime  Clockin time of the clock
   * @param  {String} clockoutTime Clockout time of the clock
   */
  function getMatch(clockinTime, clockoutTime) {
    return Adjustments.get({
      clockinTime: clockinTime,
      clockoutTime: clockoutTime
    }).$promise;
  }

  /**
   * Save or create a payrate adjustment
   *
   * @memberof TimePayrollAdjustment
   * @param  {Object} adjustment Payrate adjustment model
   */
  function save(adjustment) {
    if (adjustment.id) {
      return Adjustments.update(adjustment).$promise;
    } else {
      return Adjustments.save(adjustment).$promise;
    }
  }

  /**
   * Set the specified payrate adjustment as deleted
   *
   * @memberof TimePayrollAdjustment
   * @param  {Object} adjustment Payrate adjustment model
   */
  function remove(adjustment) {
    var copy = angular.copy(adjustment);
    copy.datestampDeleted = moment().format();
    return save(copy);
  }

  /**
   * Set the specified payrate adjustment as not deleted
   *
   * @memberof TimePayrollAdjustment
   * @param  {Object} adjustment Payrate adjustment model
   */
  function restore(adjustment) {
    var copy = angular.copy(adjustment);
    copy.datestampDeleted = null;
    return save(copy);
  }

  return {
    getAll: getAll,
    getAllActive: getAllActive,
    getMatch: getMatch,
    save: save,
    remove: remove,
    restore: restore
  };
}]);
